<template>
    <button
        type="button"
        class="btn-open"
        @click="toggleMiniCart"
    >
        <img src="/images/cart.svg" alt="" title="" />
        <span>{{ __('minicart.button.text') }}</span>
        <span class="counter" v-text="itemCount"></span>
    </button>
</template>

<script>
export default {
    props: ['itemCount', 'cartText'],

    methods: {
        toggleMiniCart: function() {
            if(!$('.cart-menu').hasClass('disable')) {
                let accountModal = $('.user-menu');
                if (accountModal) accountModal.removeClass('show');
                if($('.dropdown-bg').hasClass('d-block')){
                    $('.dropdown-bg').removeClass('d-block');
                    $('.dropdown-bg').addClass('d-none');
                }
                $('.cart-menu').toggleClass('show');
                $('.dropdown-bg').removeClass('d-none');
                $('.dropdown-bg').addClass('d-block');
            }
            event.stopPropagation();
        }
    }
};
</script>
